import React from 'react'
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import {
    MDBContainer,
    MDBInput,
    // MDBCheckbox,
    MDBTypography,
    MDBIcon
  }
  from 'mdb-react-ui-kit';

import { useFormik } from 'formik';
import { FormikLogin } from '../../interfaces/formik.interface';
import { useAuth } from '../../context/Login.context';
import { Navigate } from 'react-router-dom';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme} from "@mui/material/styles";
import {Alert} from "@mui/material"
import * as Yup from 'yup';
import Logo from '../../PuerilAlgritmo_Icon.png'
import LoadingButton from "../../componentes/LoadingButton";

const Login: React.FC = () =>{
    const auth = useAuth()
    const theme = useTheme();
    const [showPassword, setShowPassword] = React.useState(false);
    const toggleShowPassword = () => setShowPassword(!showPassword);
    const [loginError, setLoginError] = React.useState<string | null>(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
      // const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600-960px
      // const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // > 1280px

    const {handleSubmit, handleChange, handleBlur, touched, errors, isValid, dirty, isSubmitting} = useFormik<FormikLogin>({
        initialValues:{
            email: '',
            password: ''
        },
        onSubmit: async (values, {setSubmitting})=>{
            try{
                await auth.login(values.email, values.password);
            }catch (error: any){
                setLoginError(error.response?.data?.detail || 'Error de inicio de sesión');
            }finally {
                setSubmitting(false)
            }

        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Ingresa un correo electrónico válido')
                .required('Se requiere el email '),
            password: Yup.string()
                .required('Se requiere la contraseña '),
        })
    })
    if (auth.isAuth){
        return <Navigate to='/bienvenida' />
    }
    return(<>
     <MDBContainer className="p-3 my-5 d-flex flex-column w-75" style={{ maxWidth: '500px' }}>
         <form onSubmit={handleSubmit}>
             <figure className='text-center mb-0'>

                 <MDBTypography blockquote>
                     <img src={Logo as string} width={isMobile ? 150 : 250} alt='Logo'/>
                 </MDBTypography>
                 <figcaption className='blockquote-footer mb-0'>
                     el potro inteligente
                 </figcaption>

             </figure>
             <br/>
             <MDBInput
                 wrapperClass='mb-4'
                 label='Email address'
                 name='email'
                 id='email'
                 onBlur={handleBlur}
                 onChange={handleChange}
                 type='email'/>
             <div className="mb-4" style={{ position: 'relative' }}>
                 <MDBInput
                     label='Password'
                     name='password'
                     id='password'
                     onBlur={handleBlur}
                     onChange={handleChange}
                     type={showPassword ? 'text' : 'password'}
                 />
                 <MDBIcon
                     icon={showPassword ? 'eye' : 'eye-slash'}
                     className="far"
                     style={{
                         position: 'absolute',
                         right: '10px',
                         top: '50%',
                         transform: 'translateY(-50%)',
                         cursor: 'pointer',
                         zIndex: 2
                     }}
                     onClick={toggleShowPassword}
                 />
             </div>

             <div className="d-flex justify-content-between mx-3 mb-4">
                 {/* <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' /> */}
                 <a href="/forgot">No te acuerda de tu contraseña?</a>
             </div>

             <LoadingButton className="mb-4" variant={"contained"} color={"primary"} type='submit' disabled={!isValid || !dirty} loading={isSubmitting}>Ingresar</LoadingButton>
             <div className="text-center">
                 <p>No estas registrado? <a href="/register">Register</a></p>

             </div>
                 {touched.email && errors.email ? (
                     <Alert severity={'info'} color={'warning'}>{errors.email}</Alert>
                 ) : null}
                 {touched.password && errors.password ? (
                     <Alert severity={'info'} color={'warning'}>{errors.password}</Alert>
                 ) : null}
         </form>
         {loginError && (
             <Alert severity="error" sx={{ mt: 2 }}>
                 {loginError}
             </Alert>
         )}


         {/* <div className="text-center">
            <p>Not a member? <a href="#!">Register</a></p>
            <p>or sign up with:</p>

            <div className='d-flex justify-content-between mx-auto' style={{width: '40%'}}>
                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='facebook-f' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='twitter' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='google' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='github' size="sm"/>
                </MDBBtn>

            </div>
        </div> */}

        </MDBContainer>
    </>)
}

export default Login
